export default __webpack_public_path__ + "static/media/2.619a7819.png";